import React from "react";
import "./Greeting.css";
import SocialMedia from "../../components/socialMedia/SocialMedia";
import { greeting } from "../../portfolio";
import { Fade } from "react-reveal";
import FeelingProud from "./FeelingProud";

export default function Greeting(props) {
  const theme = props.theme;

  return (
    <Fade bottom duration={2000} distance="40px">
      <div className="greet-main" id="greeting">
        <div className="greeting-main">
          <div className="greeting-text-div">
            <div>
              <h1 className="greeting-text" style={{ color: theme.text }}>
                {greeting.title}
              </h1>
              {greeting.nickname && (
                <h2 className="greeting-nickname" style={{ color: theme.text }}>
                  ( {greeting.nickname} )
                </h2>
              )}
              <p
                className="greeting-text-p subTitle"
                style={{ color: theme.secondaryText }}
              >
                {greeting.subTitle}
              </p>
              {greeting.highlights.length > 0 && (
                <div className="hero-highlight-grid">
                  {greeting.highlights.map((highlight) => {
                    return (
                      <span className="hero-highlight" key={highlight}>
                        {highlight}
                      </span>
                    );
                  })}
                </div>
              )}
              {greeting.highlights.length > 0 && (
                <div className="hero-action-row">
                  <a className="hero-primary-action" href="/experience">
                    View experience
                  </a>
                </div>
              )}
              <SocialMedia theme={theme} />
            </div>
          </div>
          <div className="greeting-image-div">
            <div className="hero-illustration-card">
              <FeelingProud theme={theme} />
            </div>
          </div>
        </div>
        {greeting.stats.length > 0 && (
          <div className="hero-stats-row">
            {greeting.stats.map((stat) => {
              return (
                <div className="hero-stat-card" key={stat.label}>
                  <span className="hero-stat-value">{stat.value}</span>
                  <span className="hero-stat-label">{stat.label}</span>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </Fade>
  );
}
